/// <amd-module name="Core/Medius.Core.Web/Scripts/components/readonlyTabs/readonlyDocumentDetailsSections"/>
import * as React from 'react';
import { Card, LocalizationContext, StringMap, Notification } from '@medius/ui-controls';
import { mapFromNorthstarToApa } from '../../lib/northstarLocalization';
import { getCultureCode } from '../../Medius/lib/utils/user';
import { ContractbasedInvoiceDetails } from './details/contractbasedInvoiceDetails';
import { translate } from '../../lib/globalization';
import { IDocumentImportInformation } from './interfaces';
import { getInformation } from './services';
import { useEffect } from 'react';
import { NonPoInvoiceDetails } from './details/nonPoInvoiceDetails';
import { PoInvoiceDetails } from './details/poInvoiceDetails';
import { PrepaymentInvoiceDetails } from './details/prepaymentInvoiceDetails';
interface ReadonlyDocumentDetailComponentProps {
    documentId: string;
}

export const ReadonlyDocumentDetailsComponent = (props: ReadonlyDocumentDetailComponentProps) => {
    const [information, setInformation] = React.useState<IDocumentImportInformation | null>(null);
    const [title, setTitle] = React.useState<string>("");

    useEffect(()=>{
        getInformation(props.documentId).then(info => {
            setInformation(info);
        });
    }, [props.documentId]);

    const isNonPoInvoice = information?.documentType === "Medius.ExpenseInvoice.Entities.ExpenseInvoice";
    const isContractbasedInvoice = information?.documentType === "Medius.ContractbasedInvoice.Entities.ContractbasedInvoice";
    const isPoInvoice = information?.documentType === "Medius.OrderbasedInvoice.Entities.OrderbasedInvoice";
    const isPrepaymentInvoice = information?.documentType === "Medius.Apa.Persistence.PrepaymentInvoice.PrepaymentSupplierInvoice";

    useEffect(()=>{
        if(information){
            if(isNonPoInvoice)
                setTitle(translate("#ExpenseInvoice/LBL_EXPENSE_INVOICE_DETAILS"));
            if(isContractbasedInvoice)
                setTitle(translate("#ContractbasedInvoice/contractbasedInvoiceDetails"));
            if(isPoInvoice)
                setTitle(translate("#OrderbasedInvoice/LBL_ORDERBASED_INVOICE_DETAILS"));
            if(isPrepaymentInvoice)
                setTitle(translate("#PurchaseToPay/prepaymentInvoiceDetails"));  
        }
        else        
            setTitle(translate("#Core/mappedDocument"));
    }, [information, isNonPoInvoice, isContractbasedInvoice, isPoInvoice, isPrepaymentInvoice]);

    return (
        <div className="accordion-group">
            <LocalizationContext.Provider value={{
                translate: (key: string, _, defaultValue?: string, args?: StringMap) => mapFromNorthstarToApa(key, defaultValue, args),
                getLocale: () => getCultureCode()
            }}>
                <Card
                    data-testid="invoice-remark-card"
                    isCollapsible={true}
                    defaultOpen={true}
                    headerHeight="small"
                    title = {title}
                >
                    {information && isContractbasedInvoice && <ContractbasedInvoiceDetails information={information} />}
                    {information && isNonPoInvoice && <NonPoInvoiceDetails information={information} />}
                    {information && isPoInvoice && <PoInvoiceDetails information={information} />}
                    {information && isPrepaymentInvoice && <PrepaymentInvoiceDetails information={information} />}
                    {!!information === false && <Notification feedbackType="info" text={translate("#Core/noDocumentInformation")}/>}

                </Card>
            </LocalizationContext.Provider>
        </div>
    );
};
